import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ISimpleData } from '../../../../../shared/models/simpleData.model';
import { GeneralSettingsService } from '../../../../../services/general-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../services/toast.service';

@Component({
  selector: 'app-add-edit-passenger-classes-dialog',
  templateUrl: './add-edit-passenger-categories-dialog.component.html',
  styleUrls: ['./add-edit-passenger-categories-dialog.component.scss']
})
export class AddEditPassengerCategoriesDialogComponent implements OnInit {

  form?: UntypedFormGroup;
  isBusy = false;
  @Input() passengerCategory?: ISimpleData;
  @Input() title?: string;
  constructor(private generalSettingsService: GeneralSettingsService, private activeModal: NgbActiveModal, private toastService: ToastService) { }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      code: new UntypedFormControl(this.passengerCategory?.code || '', Validators.required),
      description: new UntypedFormControl(this.passengerCategory?.description || '', Validators.required)
    });
  }

  closeModal(reason?: any) {
    this.activeModal.dismiss(reason);
  }

  onSaveClick() {
    const data = { ...this.form.value, id: this.passengerCategory?.id };
    this.isBusy = true;
    this.generalSettingsService.savePassengerCategory(data).subscribe((result) => {
      if(result?.id) {
        this.toastService.showSuccess("Passenger category has been saved");
        this.closeModal(true);
      }
      this.isBusy = false;
    });
  }

}
